import React, {useEffect, useState} from "react";
import Storage from "../../services/storage.service";
import Helpers from "../../helpers/shared.helper";

const OfferActiveCard = ({offer, translationKeys, prefix}) => {
    const [poOfferIcon, setPoOfferIcon] = useState({});
    useEffect(() => {
        let offerIcon = JSON.parse(Storage.get('offers_images', true));
        setPoOfferIcon(offerIcon);
    }, []);

    const timeDuration = (duration) => {
        let durationField = "";
        if (duration === -1) {
          //If unlimited
          durationField = translationKeys[prefix + "unlimited"];
        } else {
          durationField = Helpers.monthsInDay(duration);
    
          if (durationField === 1) {
            durationField += " " + translationKeys[prefix + "month"];
          } else {
            durationField += " " + translationKeys[prefix + "months"];
          }
        }
        return durationField;
      };
  return (
    <div className="card-wrapper">
      <div className={'card active-card'}>
        <div className="card-header">
          <div className="card-left-section">
            <img
              src={
                offer?.PromotionId
                  ? poOfferIcon[`offer_${offer?.PromotionId}_selected`]?.url
                  : "not found"
              }
              alt={"tower"}
            />
            <div className="card-title">
              <p className="title-upper active-card">
                {offer?.PromoCode
                  ? translationKeys[prefix + "Promo_code"] +
                    " (" +
                    offer?.PromoCode +
                    ")"
                  : translationKeys[
                      `applied_offer_title_${offer?.PromotionId}`
                    ]}
              </p>
              <p className="title-lower active-card">
                {timeDuration(offer.PromotionDuration)}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfferActiveCard;
